import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var fractionDelimiter = ',';
var digitFormatterRegexp = /\d(?=(\d{3})+(,|$))/g;
var digitSectionDelimiter = '$& ';
export var pipe = function pipe() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }
  return ops.reduce(function (a, b) {
    return function (arg) {
      return b(a(arg));
    };
  });
};
export var empty = function empty(str) {
  return str.length === 0;
};
export var trimmer = function trimmer(str) {
  return str.trim();
};
export var toInt = function toInt(str) {
  return empty(str) ? NaN : parseFloat(str);
};
export var normalizeNumber = function normalizeNumber(str) {
  return str.replace(/,,|\.\.|\.,|,\.|,/, '.').replace(/[^.|\d]/g, '');
};
export var takeUntill = function takeUntill(amount) {
  return function (str) {
    return str.length <= amount ? str : str.slice(0, amount);
  };
};
export var formatNumber = function formatNumber(digitFraction) {
  return function (str) {
    var _str$split = str.split('.'),
      _str$split2 = _slicedToArray(_str$split, 2),
      digit = _str$split2[0],
      fraction = _str$split2[1];
    var base = digit.replace(digitFormatterRegexp, digitSectionDelimiter);
    var fractional = digitFraction && fraction !== undefined ? fractionDelimiter + fraction.slice(0, digitFraction) : '';
    return base + fractional;
  };
};
export var applyMaxLimit = function applyMaxLimit(limit) {
  return function (str) {
    var point = str[str.length - 1] == '.' ? '.' : '';
    var prepared = toInt(str);
    var result = prepared <= limit ? prepared + point : limit;
    return str ? result.toString() : str;
  };
};
export var fractionTakeUntill = function fractionTakeUntill(amount) {
  return function (str) {
    var _str$split3 = str.split('.'),
      _str$split4 = _slicedToArray(_str$split3, 2),
      digit = _str$split4[0],
      fraction = _str$split4[1];
    return fraction ? [digit, takeUntill(amount)(fraction)].join('.') : str;
  };
};
export function toString(value) {
  var result = value;
  if (typeof value === 'number') {
    result = String(value);
  }
  if (typeof value === 'number' && isNaN(value) || value === null || typeof value === 'undefined') {
    result = '';
  }
  return result;
}
export var clearCountryPrefix = function clearCountryPrefix(str) {
  return str.length >= 11 ? str.replace(/^\+*[78](\d)/, '$1') : str;
};
export var clearFormatting = function clearFormatting(str) {
  return str.replace(/\D/g, '');
};